/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Learn_Mistakestypemermaidfillinblank5Inputs */

const zh_learn_mistakestypemermaidfillinblank5 = /** @type {(inputs: Learn_Mistakestypemermaidfillinblank5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`图表填空`)
};

const en_learn_mistakestypemermaidfillinblank5 = /** @type {(inputs: Learn_Mistakestypemermaidfillinblank5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diagram Fill in Blank`)
};

const es_learn_mistakestypemermaidfillinblank5 = /** @type {(inputs: Learn_Mistakestypemermaidfillinblank5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diagrama para completar`)
};

/**
* | output |
* | --- |
* | "Diagram Fill in Blank" |
*
* @param {Learn_Mistakestypemermaidfillinblank5Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const learn_mistakestypemermaidfillinblank5 = /** @type {((inputs?: Learn_Mistakestypemermaidfillinblank5Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Learn_Mistakestypemermaidfillinblank5Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_learn_mistakestypemermaidfillinblank5(inputs)
	if (locale === "en") return en_learn_mistakestypemermaidfillinblank5(inputs)
	return es_learn_mistakestypemermaidfillinblank5(inputs)
});
export { learn_mistakestypemermaidfillinblank5 as "learn_mistakesTypeMermaidFillInBlank" }